import { useAuth } from "@/context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading, subscription, subscriptionActive } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-app">
        <p className="text-text-muted">Laddar…</p>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;

  // Subscription-guard: om organisationen inte är trialing/active/grandfathered
  // tvinga användaren till /billing (även om användaren är anställd, för då kan
  // hen kontakta sin admin). Undantag: super-admin kringgår alltid.
  if (subscription && !subscriptionActive && !user.is_super_admin) {
    return <Navigate to="/billing" replace />;
  }

  return children;
}
